import { render, staticRenderFns } from "./OfferTraid.vue?vue&type=template&id=764f4848&"
import script from "./OfferTraid.vue?vue&type=script&lang=js&"
export * from "./OfferTraid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports